import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  PartnerDocumentListApi,
  PartnerDocumentListQuery,
  PartnerDocumentReviewPayload,
  PartnerDocumentStats,
} from '../../partner-management/models/partner-document-listing-row';

export const DocumentVerificationActions = createActionGroup({
  source: 'Document Verification',
  events: {
    'Load List': props<{ query: PartnerDocumentListQuery }>(),
    'Load List Success': props<{
      rows: PartnerDocumentListApi[];
      total: number;
      page: number;
      pageSize: number;
      stats: PartnerDocumentStats;
    }>(),
    'Load List Failure': props<{ error: string }>(),
    'Review Document': props<{
      partnerId: string;
      documentId: string;
      payload: PartnerDocumentReviewPayload;
      query: PartnerDocumentListQuery;
    }>(),
    'Review Document Success': props<{ message: string }>(),
    'Review Document Failure': props<{ error: string }>(),
    'Clear Error': emptyProps(),
    'Clear Success Message': emptyProps(),
  },
});
